"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _Button = _interopRequireDefault(require("../Button/Button.styles"));
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors;
  var _props$isBtnView = props.isBtnView,
    isBtnView = _props$isBtnView === void 0 ? false : _props$isBtnView,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    _props$customStyle = props.customStyle,
    customStyle = _props$customStyle === void 0 ? {} : _props$customStyle;
  var buttonStyles = (0, _Button.default)(props);
  var ccAStyle = (0, _react.useMemo)(function () {
    var colorProps = function colorProps() {
      var textColor = color === 'primary' ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main : themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text;
      return {
        color: textColor
      };
    };
    var ccA = (0, _css.css)(_objectSpread(_objectSpread(_objectSpread({
      fontFamily: fontFamily,
      cursor: 'pointer',
      textDecoration: 'none',
      fontSize: 'inherit'
    }, colorProps()), customStyle), {}, {
      '&:hover, &:focus': {
        textDecoration: 'underline'
      },
      '&[data-disabled=true]': {
        opacity: '0.5',
        cursor: 'default',
        pointerEvents: 'none'
      }
    }));
    return ccA;
  }, [fontFamily, customStyle, color, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text]);
  var ccLinkBtn = buttonStyles['cc-Button'];
  return {
    'cc-A': isBtnView ? ccLinkBtn : ccAStyle
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;